import { LessonPageModeEnum } from 'screens/ExploreLessons/enums';
import MarketplaceEmptyPlaceholder from 'components/MarketplaceEmptyPlaceholder';
import classNames from 'styles/utils/classNames';
import InstantBookSection from './InstantBookSection';
import LoadingGrid from './LoadingGrid';
import OtherCoachesSection from './OtherCoachesSection';
import SingleCoachSection from './SingleCoachSection';
import { LessonListProps } from './props';

const LessonList: React.FC<LessonListProps> = ({
  instantBookEligibleCoaches,
  nonInstantBookEligibleCoaches,
  allCoaches,
  loading,
  listHoveredCoachId,
  setListHoveredCoachId,
  activeSport,
  pageMode,
  onClearFilters,
  vairProMap,
}) => {
  const totalCoaches = allCoaches.length;
  const isExploreMode = pageMode === LessonPageModeEnum.EXPLORE;
  const hasInstantBookCoaches = instantBookEligibleCoaches.length > 0;

  // Show empty state when no coaches and not loading
  if (!loading && totalCoaches === 0) {
    return (
      <MarketplaceEmptyPlaceholder
        title="Hang tight! We'll have coaches in this area soon!"
        onClearFilters={onClearFilters}
      />
    );
  }

  return (
    <div className={classNames('flex h-full w-full flex-col', hasInstantBookCoaches && 'sm:pt-3')}>
      {loading ? (
        <LoadingGrid />
      ) : isExploreMode ? (
        <>
          {/* EXPLORE Mode: Two-section layout */}
          <InstantBookSection
            coaches={instantBookEligibleCoaches}
            listHoveredCoachId={listHoveredCoachId}
            setListHoveredCoachId={setListHoveredCoachId}
            activeSport={activeSport}
            vairProMap={vairProMap}
          />

          <OtherCoachesSection
            coaches={nonInstantBookEligibleCoaches}
            listHoveredCoachId={listHoveredCoachId}
            setListHoveredCoachId={setListHoveredCoachId}
            activeSport={activeSport}
            hasInstantBookSection={hasInstantBookCoaches}
            vairProMap={vairProMap}
          />
        </>
      ) : (
        /* PPR/PTR/PCR Modes: Single-section layout with all coaches (preserves original sorting) */
        <SingleCoachSection
          coaches={allCoaches}
          listHoveredCoachId={listHoveredCoachId}
          setListHoveredCoachId={setListHoveredCoachId}
          activeSport={activeSport}
          vairProMap={vairProMap}
        />
      )}
    </div>
  );
};

export default LessonList;
